import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from './../models/app-config';
@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private appConfig: AppConfig;

  constructor(private http: HttpClient) {}

  loadAppConfig(): Promise<void | AppConfig> {
    return this.http
      .get<AppConfig>('/clientconfig.json')
      .toPromise<AppConfig>()
      .then((data) => {
        this.appConfig = data;
      });
  }

  get Config(): AppConfig {
    return this.appConfig;
  }

  get vistekUrl(): string {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.VistekUrl;
  }
  get paypalEnvironment(): string {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.PaypalEnvironment;
  }

  get klaviyoFormsSettings(): AppConfig['KlaviyoFormsSettings'] {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.KlaviyoFormsSettings;
  }

  get klaviyoSubscriptionListSettings(): AppConfig['KlaviyoSubscriptionListSettings'] {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.KlaviyoSubscriptionListSettings;
  }

  get instrumentationKey(): string {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.InstrumentationKey;
  }

  get appVersion(): string {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.AppVersion;
  }
}
